import {
  brainBlitzLogo,
  quickPickLogo,
  quickRankLogo,
  rankifierLogo,
  swiperLogo,
  wordopolisLogo,
  wordUpLogo,
} from "@datagame/ui";

import { GameKindWithQuickPick } from "./components/project/ProjectView/ProjectSettings/Steps/AddGames/AddGameForm/AddGameForm";

export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\d\S\s]+$/g;

export const GAME_IMAGE_ATTRS: {
  [key in GameKindWithQuickPick]: {
    src: string;
    alt: string;
  };
} = {
  SWIPER: {
    src: swiperLogo,
    alt: "Swiper",
  },
  QUICK_RANK: {
    src: quickRankLogo,
    alt: "QuickRank",
  },
  RANKIFIER: {
    src: rankifierLogo,
    alt: "Rankifier",
  },
  WORDOPOLIS: {
    src: wordopolisLogo,
    alt: "Wordopolis",
  },
  QUICK_PICK: {
    src: quickPickLogo,
    alt: "QuickPick",
  },
  TRIVIA: {
    // TODO: update when designs are ready
    src: brainBlitzLogo,
    alt: "Brain Blitz",
  },
  WORDLE: {
    // TODO: update when designs are ready
    src: wordUpLogo,
    alt: "WordUp",
  },
};

export const LEADERBOARD_TEST_RESULTS = [
  {
    nickname: "John Doe",
    points: 100,
    rank: 1,
    timeInMs: 1000,
  },
  {
    nickname: "Starfish",
    points: 80,
    rank: 2,
    timeInMs: 1200,
  },
  {
    nickname: "Sunny",
    points: 60,
    rank: 3,
    timeInMs: 6000,
  },
  {
    nickname: "Yellow",
    points: 60,
    rank: 4,
    timeInMs: 12000,
  },
  {
    nickname: "Blue",
    points: 40,
    rank: 5,
    timeInMs: 10030,
  },
  {
    nickname: "Red",
    points: 40,
    rank: 6,
    timeInMs: 12000,
  },
  {
    nickname: "Green",
    points: 30,
    rank: 7,
    timeInMs: 96040,
  },
  {
    nickname: "Purple",
    points: 20,
    rank: 8,
    timeInMs: 3000,
  },
  {
    nickname: "Orange",
    points: 10,
    rank: 9,
    timeInMs: 4241,
  },
  {
    nickname: "Pink",
    points: 10,
    rank: 10,
    timeInMs: 122000,
  },
  {
    nickname: "Brown",
    points: 0,
    rank: 11,
    timeInMs: 42000,
  },
];
